import { render, staticRenderFns } from "./MainBookCard3ByTypesPrint.vue?vue&type=template&id=1cb00a38&scoped=true"
import script from "./MainBookCard3ByTypesPrint.vue?vue&type=script&lang=js"
export * from "./MainBookCard3ByTypesPrint.vue?vue&type=script&lang=js"
import style0 from "./MainBookCard3ByTypesPrint.vue?vue&type=style&index=0&id=1cb00a38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb00a38",
  null
  
)

export default component.exports